module.exports = __webpack_public_path__ + "static/img/btn_icon.8e1cf464.png";